// extracted by mini-css-extract-plugin
export var barContainer = "_52-0";
export var extraThin = "_52-3";
export var fillBar = "_52-6";
export var fillContainer = "_52-4";
export var overflow = "_52-8";
export var overflowContainer = "_52-5";
export var regular = "_52-7";
export var thick = "_52-1";
export var thin = "_52-2";